import React from 'react'
import MaterialSymbol from '../material-symbol'

const Settings = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="settings" {...props} />
))

Settings.displayName = 'Settings'

export default Settings
